<template>
  <ODialog ref="dialog" :max-width="1300" hideWhenLoading :persistent="isDirty">
    <v-card v-if="row != null">
      <ODialogBar title="Câmera JIMI" :subtitle="subtitle" @close="dismiss">
        <v-spacer />
        <v-btn icon target="_blank" :to="'/setup/cameras/' + row.id">
          <v-icon>mdi-open-in-new</v-icon>
        </v-btn>
      </ODialogBar>
      <v-card-text class="dialog-main dialog-maxh-calc">
        <div class="dialog-sidebar w-256">
          <DesktopSideBar :tabItems="tabItems" :currentTab.sync="currentTab" />
        </div>

        <div class="dialog-tab-content">
          <TabContainer
            @reload="reload"
            :tabItems="tabItems"
            :currentTab="currentTab"
            :value="row"
          />
        </div>
      </v-card-text>
    </v-card>
  </ODialog>
</template>

<script>
import DesktopSideBar from 'oderon-vue/cpts/tabbed-interface/DesktopSideBar.vue'
import TabContainer from 'oderon-vue/cpts/tabbed-interface/TabContainer.vue'
import EditStore from './EditStore'

export default {
  components: {
    DesktopSideBar,
    TabContainer
  },
  computed: {
    currentTab: {
      get() {
        return EditStore.currentTab
      },
      set(x) {
        EditStore.currentTab = x
      }
    },
    row() {
      return EditStore.row
    },
    isDirty() {
      return EditStore.isDirty
    },
    subtitle() {
      const id = this.row && this.row.id
      const imei = this.row && this.row.imei
      if (id == null || imei == null) return null
      return `ID #${this.row.id} ─ IMEI ${this.row.imei}`
    },
    tabItems() {
      return EditStore.tabItems
    }
  },
  methods: {
    open(id) {
      this.$refs.dialog.$loading(() => EditStore.load(id))
      return this.$refs.dialog.$open()
    },
    reload() {
      this.$refs.dialog.$loading(() => EditStore.load(this.row.id))
    },
    dismiss() {
      return this.$refs.dialog.$dismiss()
    }
  }
}
</script>

<style lang="sass"></style>
